import { useMemo } from "react";

import useStorage from "fe-shared/src/hooks/useStorage";
import { getRequestParams } from "fe-shared-transactions/src/helpers/transactionsRequestConverter";
import {
  DataGridFilters,
  DataGridOptions,
} from "fe-shared/src/components/DataGrid/modules/types";

const useInvoicesRequestParams = () => {
  const [options, setOptions] = useStorage<DataGridOptions>(
    "portalInvoicesOptions",
    {
      sortDirection: "desc",
      sortField: "submittedDate",
    },
    true
  );
  const [filters, setFilters] = useStorage<DataGridFilters>(
    "portalInvoicesFilters",
    {},
    true
  );

  const requestParams = useMemo(() => getRequestParams(filters, options), [
    filters,
    options,
  ]);

  return {
    options,
    filters,
    setOptions,
    setFilters,
    requestParams,
  };
};

export default useInvoicesRequestParams;
